import { KYMW4700Model } from '../kymw4700.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

export type GetMultiCodeListResponse = {
  TotalNum: string;
  StartDispNum: string;
  EndDispNum: string;
  MultiCodeList: {
    MultiCode: string;
    GuideGoodsName: string;
    GuideStandardName: string;
    MakerName: string;
    PayeeClient: string;
  }[];
};

/**
 * マルチコード一覧取得
 *
 * @export API通信成功時の処理
 * @class GetMultiCodeListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetMultiCodeListService extends PlessJsonResponderSub<GetMultiCodeListResponse> {
  // 処理に使用するModel および Vo
  private model: KYMW4700Model = null;
  successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCodeListService
   */
  private getBody(): PlessRequest {
    let combinations = [];
    let searchObj = {};
    
    if (this.model.kymw0300output.pcodeList.length > 0) {
      // Pコードリスト検索
      this.model.kymw0300output.pcodeList.map((item) => {
        const addItem = {
          parameter: {
            GuideGoodsName: "",
            GuideStandardName: "",
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            Duties: "",
            PCode: item,
            ItemCode: "",
          }
        }
        combinations.push(addItem);
      })
    } 
    else if (this.model.kymw0300output.itemcodeList.length > 0) {
      // アイテムコードリスト検索
      this.model.kymw0300output.itemcodeList.map((item) => {
        const addItem = {
          parameter: {
            GuideGoodsName: "",
            GuideStandardName: "",
            TagId: "",
            GoodsMark: "",
            CoopCode: "",
            Duties: "",
            PCode: "",
            ItemCode: item,
          }
        }
        combinations.push(addItem);
      })
    } 
    else {
      const guideGoodsName = this.model.kymw0300output.guideGoodsNameList;
      const guideStandardName = this.model.kymw0300output.guideStandardNameList;
      const tagId = this.model.kymw0300output.tagId;
      const goodsMark = this.model.kymw0300output.goodsMark;
      const coopCodeList = this.model.kymw0300output.coopCodeList;
      const duties = this.model.kymw0300output.duties;

      const maxLength = Math.max(guideGoodsName.length, guideStandardName.length, tagId.length, goodsMark.length, coopCodeList.length, duties.length);

      combinations = Array.from({ length: maxLength }, (_, index) => ({
        parameter: {
          GuideGoodsName: guideGoodsName[index] !== undefined ? guideGoodsName[index] : "",
          GuideStandardName: guideStandardName[index] !== undefined ? guideStandardName[index] : "",
          TagId: tagId[index] !== undefined ? tagId[index] : "",
          GoodsMark: goodsMark[index] !== undefined ? goodsMark[index] : "",
          CoopCode: coopCodeList[index] !== undefined ? coopCodeList[index] : "",
          Duties: duties[index] !== undefined ? duties[index] : "",
          PCode: "",
          ItemCode: "",
        }
      }))
    }

    searchObj = {
      Rec: {
        parameter: {
          PCode: this.model.kymw0300output.pcode,
          ItemCode: this.model.kymw0300output.itemCode,
          JanCode: this.model.kymw0300output.janCode,
          MakerName: this.model.kymw0300output.makerName,
          TagSearchType: this.model.kymw0300output.tagSearchType,
          GoodsMarkSearchType: this.model.kymw0300output.goodsMarkSearchType,
          // 初期表示で''設定 商品検索を開くと'true'|'false'設定
          DataKbnFlg: this.model.dataKbnFlg,
          GoodsDiv: this.model.kymw0300output.goodsDiv,
          BuyerCode: this.model.kymw0300output.buyerCode,
          AdmitStatus: this.model.kymw0300output.admitStatus,
          RegistDateFrom: this.model.kymw0300output.registDateFrom,
          RegistDateTo: this.model.kymw0300output.registDateTo,
          UpdateDateFrom: this.model.kymw0300output.updateDateFrom,
          UpdateDateTo: this.model.kymw0300output.updateDateTo,
          ClassCode: this.model.kymw0300output.classCode,
          MiddleClassCode: this.model.kymw0300output.middleClassCode,
          SmallClassCode: this.model.kymw0300output.smallClassCode,
          OrdrClientCode: this.model.kymw0300output.ordrClientCode,
          OrdrClientKanji: this.model.kymw0300output.ordrClientKanji,
          PayeeClientCode: this.model.kymw0300output.payeeClientCode,
          PayeeClientKanji: this.model.kymw0300output.payeeClientKanji,
          Page: this.model.reqPageNum.toString(),
        },
        combination: combinations
      }
    }
    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4700Model} model
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetMultiCodeListService
   */
  execute(model: KYMW4700Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getMultiCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMultiCodeListService
   */
  success(data: GetMultiCodeListResponse) {
    if (this.successFunc) {
      this.successFunc();
    }
    if (data) {
      this.model.setSearchResult(data);
    }
  }
}
